export function isDesktopViewport() {
  return window.matchMedia('(min-width: 1024px)').matches;
}
